<template>
<layout-content>
  <template #headerTitle>
    <div style="display:flex;gap:6px;float:left;">
      <h1 class="layout-content-header-text">{{$route.meta.label}}</h1>

      <data-time-query :query="query" />

      <el-button
        type="orange"
        size="small"
        icon="el-icon-search"
        style="margin-left:0;"
        @click="onSearchReportBtnClick"
      >查询</el-button>
    </div>
  </template>

  <template #toolbar>
    <el-button
      type="warning"
      icon="el-icon-document-add"
      size="small"
      style="margin-left:0;"
      @click="onCreateReportBtnClick"
    >生成</el-button>

    <el-button
      :disabled="!hasReport"
      type="primary"
      icon="el-icon-upload"
      size="small"
      style="margin-left:0;"
      @click="onSaveReportBtnClick"
    >保存</el-button>

    <el-button
      :disabled="!hasReport"
      type="success"
      icon="el-icon-download"
      size="small"
      style="margin-left:0;"
      @click="onExportReportBtnClick"
    >导出</el-button>
  </template>

  <template #body>
    <data-wrapper class="data-editor-wrapper">
      <div class="report-data-display-wrapper">
        <el-table
          ref="table"
          :data="reports"
          border
          stripe
          highlight-current-row
          header-row-class-name="custom-table-header"
          height="100%"
          class="custom-table no-inner-border"
          style="width: 100%"
          @row-click="onTableRowClick"
        >
          <el-table-column label="序号" width="50">
            <template slot-scope="{$index}">{{$index + 1}}</template>
          </el-table-column>

          <el-table-column label="报表时间范围">
            <template slot-scope="{row}">{{row.beginTime}}~{{row.endTime}}</template>
          </el-table-column>

          <el-table-column label="报表创建时间" prop="createTime" />
          <el-table-column label="报表最近修改时间" prop="updateTime" />
        </el-table>
      </div>

      <div class="html-content-editor-wrapper">
        <div class="html-content-editor-inner">
          <vue-ueditor-wrap v-model="htmlContent" :config="editorConfig" class="html-content-editor" />
        </div>
      </div>
    </data-wrapper>
  </template>

  <template #editor>
    <creator ref="creator" @report-created="onReportCreated" />
  </template>
</layout-content>
</template>

<script>
import BaseDateData from '../../../BaseDateData'
import LayoutContent from '../../../../components/Layout/Content'
import DataTimeQuery from '../../../../components/Data/Query/DataTimeQuery'
import DataWrapper from '../../../../components/Data/DataWrapper'
import VueUeditorWrap from 'vue-ueditor-wrap'
import Creator from './Creator'

export default {
  name: 'PollutionProcess',
  routeInfo: {
    label: '污染过程报告',
    icon: 'fa fa-users'
  },
  extends: BaseDateData,
  components: {Creator, DataWrapper, DataTimeQuery, LayoutContent, VueUeditorWrap},
  data: () => ({
    htmlContent: '',
    oHtmlContent: '',
    currentReportId: null,
    reports: Object.freeze([])
  }),
  computed: {
    queryTimeStep: () => 7,
    endTimeDiff: () => 1,
    editorConfig: () => ({
      // 设置编辑器不自动被内容撑高
      autoHeightEnabled: false,
      // 初始容器宽度
      initialFrameWidth: '100%',
      // 初始容器高度
      // initialFrameHeight: '100%',
      focus: true,
      initialStyle: 'body{height:auto!important;margin:0!important;padding:2.54cm 1.52cm 2.54cm 1.27cm!important;}p{line-height:1.5;text-align:justify;}',
      toolbars: [[
        // 'fullscreen',
        // 'source',
        // '|',
        'undo',
        'redo',
        '|',
        'bold',
        'italic',
        'underline',
        'fontborder',
        'strikethrough',
        'superscript',
        'subscript',
        'removeformat',
        'formatmatch',
        'blockquote',
        '|',
        'forecolor',
        'backcolor',
        'insertorderedlist',
        'insertunorderedlist',
        '|',
        'rowspacingtop',
        'rowspacingbottom',
        'lineheight',
        '|',
        'customstyle',
        'paragraph',
        'fontfamily',
        'fontsize',
        '|',
        'indent',
        '|',
        'justifyleft',
        'justifycenter',
        'justifyright',
        'justifyjustify',
        '|',
        'touppercase',
        'tolowercase',
        '|',
        'pagebreak',
        '|',
        'horizontal',
        'spechars',
        'wordimage',
        '|',
        'inserttable',
        'deletetable',
        'insertparagraphbeforetable',
        'insertrow',
        'deleterow',
        'insertcol',
        'deletecol',
        'mergecells',
        'mergeright',
        'mergedown',
        'splittocells',
        'splittorows',
        'splittocols',
        'charts',
        '|',
        'imagenone',
        'imageleft',
        'imageright',
        'imagecenter',
        '|',
        'help'
      ]],
      fontsize: [10, 11, 12, 14, 16, 18, 20, 24, 26, 28, 30, 32, 34, 36, 48, 72],
      elementPathEnabled: false,
      wordCount: false,
      // 可以放后台存放路径
      serverUrl: '',
      // UEditor 是文件的存放路径，
      UEDITOR_HOME_URL: '/static/Ueditor/'
    }),
    hasReport () {
      return !!this.oHtmlContent
    }
  },
  methods: {
    getReportList (flag = true) {
      this.changeLoadStatus(true)
      this.currentQuery = JSON.parse(JSON.stringify(this.query))

      this.$api.WordReport.getPollutionProcessReports(this.query).then(list => {
        this.reports = Object.freeze(list.map(item => ({
          id: item.id,
          beginTime: new Date(item.beginTime).format('YYYY年MM月DD日HH时'),
          endTime: new Date(item.endTime).format('YYYY年MM月DD日HH时'),
          createTime: new Date(item.endTime).format('YYYY年MM月DD日HH时mm分'),
          updateTime: new Date(item.updateTime).format('YYYY年MM月DD日HH时mm分')
        })))

        if (list.length > 0) {
          if (flag) {
            this.getReport(list[0].id)
          }
        }
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onSearchReportBtnClick () {
      this.getReportList()
    },
    onCreateReportBtnClick () {
      this.$refs.creator.open()
    },
    onSaveReportBtnClick () {
      if (this.isCreated()) {
        const htmlContent = this.getHtmlContent()

        if (htmlContent[1]) {
          this.saveReport(htmlContent[0], [() => {
            this.$notify({
              title: '提示',
              message: '保存成功',
              type: 'success',
              position: 'bottom-right'
            })
          }])
        }
      }
    },
    onExportReportBtnClick () {
      if (this.isCreated()) {
        const htmlContent = this.getHtmlContent()

        if (htmlContent[1]) {
          this.saveReport(htmlContent[0], [this.exportReport, this.downloadReport])
        } else {
          this.changeLoadStatus(true)
          this.exportReport().then(this.downloadReport).catch(console.error).finally(() => {
            this.changeLoadStatus(false)
          })
        }
      }
    },
    onReportCreated ({html, data, id}) {
      this.currentReportId = id
      this.setResponseResult(html, false)
      this.getReportList(false)
    },
    setResponseResult (htmlContent, isLoadData) {
      this.oHtmlContent = htmlContent = this.getFormatHtmlContent(htmlContent)
      this.htmlContent = htmlContent.replace(/src="image\//g, `src="/report/pollution/${this.currentReportId}/image/`)
    },
    getFormatHtmlContent (htmlContent) {
      return (htmlContent || '').replace(/(line-height:\s*\d*(\.\d+)?)em/ig, (match, replacement) => replacement)
    },
    isCreated () {
      if (!this.hasReport) {
        this.$alert('请先生成报表', '提示', {
          confirmButtonText: '确定'
        })

        return false
      }

      return true
    },
    getHtmlContent () {
      const htmlContent = this.getFormatHtmlContent(this.htmlContent).replaceAll(`src="/report/pollution/${this.currentReportId}/image/`, `src="image/`)
      return [htmlContent, htmlContent !== this.oHtmlContent]
    },
    saveReport (htmlContent, callbacks) {
      this.changeLoadStatus(true)

      let promise = this.$api.WordReport.savePollutionProcessReport(this.currentReportId, htmlContent).then(() => new Promise(resolve => {
        this.oHtmlContent = htmlContent
        resolve()
      }))

      callbacks.forEach(callback => {
        promise = promise.then(callback)
      })

      promise.catch(console.error).finally(() => {
        htmlContent = null
        this.changeLoadStatus(false)
      })
    },
    exportReport () {
      return this.$api.WordReport.exportPollutionProcessReport(this.currentReportId)
    },
    downloadReport (reportPath) {
      if (reportPath) {
        const link = document.createElement('a')
        const path = reportPath.split('/')
        const pathLength = path.length
        const {currentReportId} = this
        const reportName = path[pathLength - 1]
        const report = this.reports.find(report => report.id === currentReportId)

        link.download = `${report.beginTime}-${report.endTime}${reportName}`
        link.href = `/report/${reportPath}`
        link.click()
      }
    },
    getReport (reportId) {
      setTimeout(() => {
        this.changeLoadStatus(true)

        this.$api.WordReport.getPollutionProcessReport(reportId).then(html => {
          this.currentReportId = reportId
          this.setResponseResult(html, false)

          const report = this.reports.find(report => report.id === reportId)
          report && this.$refs.table.setCurrentRow(report)
        }).catch(console.error).finally(() => {
          reportId = null
          this.changeLoadStatus(false)
        })
      }, 0)
    },
    onTableRowClick (row) {
      this.getReport(row.id)
    }
  },
  created () {
    this.getReportList()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/06Data-Management/03Report/02PollutionProcess/index.vue